var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<ul>\n<li ng-repeat=\"(label, url) in moduloCtrl.listaLink\">\n<a href=\"{{url}}\">{{label}}</a>\n</li>\n</ul>";
var id1="fatture.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;